import { render, staticRenderFns } from "./narratives-table.vue?vue&type=template&id=03293f4e"
import script from "./narratives-table.vue?vue&type=script&lang=js"
export * from "./narratives-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports